import React, { useEffect, useRef, useState } from "react";
import { MenuIcon, PhoneIcon, XIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { firm, logos } from "../../data/site";
import { actionClass } from "../../utils/actionStyles";
import { SiteLink } from "../SiteLink";
import { DesktopNav } from "./DesktopNav";
import { MobileMenu } from "./MobileMenu";
const MENU_ID = "site-menu";
export function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuButtonRef = useRef<HTMLButtonElement>(null);
  const headerRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const header = headerRef.current;
    if (!header) return;
    const root = document.documentElement;
    const measure = () => {
      const bounds = header.getBoundingClientRect();
      root.style.setProperty("--site-header-height", `${bounds.height}px`);
      root.style.setProperty("--site-menu-top", `${Math.max(0, bounds.bottom)}px`);
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(header);
    window.addEventListener("scroll", measure, {
      passive: true
    });
    window.addEventListener("resize", measure);
    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", measure);
      window.removeEventListener("resize", measure);
    };
  }, []);
  useEffect(() => {
    if (!menuOpen) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        setMenuOpen(false);
        menuButtonRef.current?.focus();
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [menuOpen]);
  const logoAlt = `${firm.displayName} — home`;
  return <header ref={headerRef} className="site-header sticky top-0 z-40 border-b border-line bg-white shadow-sm" data-id="element-123" data-mp="1pe9cliqf5xv0">
      <div className="mx-auto flex w-full max-w-[1440px] items-center justify-between gap-3 px-3.5 py-1 sm:px-5 nav:gap-8 nav:px-8 nav:py-1" data-id="element-124" data-mp="1thfi2o5pjl0f">
        <Link to="/" aria-label={logoAlt} className="brand-home shrink-0" onClick={() => setMenuOpen(false)} data-id="element-125" data-mp="3w549gya6i16o">
          <img src={logos.compact.src} width={logos.compact.width} height={logos.compact.height} alt="" className="h-[62px] w-[62px] nav:h-[96px] nav:w-[96px]" data-id="element-126" data-mp="3md8dbsrnkl53" />
          <span className="brand-wordmark hidden nav:block" aria-hidden="true" data-id="element-127" data-mp="3ddlad2j9z79x">
            <span data-id="element-128" data-mp="38cxmgpqcf6jx">Jason Waechter- </span>
            <span data-id="element-129" data-mp="38bvzbmw1ytlu">THE Motorcycle Lawyer®</span>
          </span>
        </Link>

        <div className="hidden items-center gap-5 nav:flex" data-id="element-130" data-mp="33ffccw0lalac">
          <a href={firm.phoneHref} className="inline-flex min-h-[52px] items-center gap-3 text-[26px] font-bold leading-tight text-ink hover:text-crimson" data-id="element-131" data-mp="2yfj3ojgy65og">
            <PhoneIcon aria-hidden="true" className="h-7 w-7 text-crimson" data-id="element-132" data-mp="wo61i26d6bw3" />
            <span className="sr-only" data-id="element-133" data-mp="wltps6r78xrh">Call </span>
            {firm.phoneDisplay}
          </a>
          <SiteLink path="/#case-review" className={actionClass("call")} data-id="element-134" data-mp="152u6ermnrb58">
            Free Case Review
          </SiteLink>
        </div>

        <div className="flex items-center gap-2.5 nav:hidden" data-id="element-135" data-mp="1dwyu526hw6gj">
          <button ref={menuButtonRef} type="button" aria-expanded={menuOpen} aria-controls={MENU_ID} onClick={() => setMenuOpen(open => !open)} className={actionClass("outline", "!px-3.5 sm:!px-5")} data-id="element-136" data-mp="1dzl4taoon22z">
            {menuOpen ? <XIcon aria-hidden="true" className="h-5 w-5" data-id="element-137" data-mp="v67qmh96vaa2" /> : <MenuIcon aria-hidden="true" className="h-5 w-5" data-id="element-138" data-mp="105u48rsxisje" />}
            {menuOpen ? "Close" : "Menu"}
          </button>
          <a href={firm.phoneHref} className={actionClass("call", "!px-3.5 sm:!px-5")} data-id="element-139" data-mp="26kus0a7sw4ew">
            <PhoneIcon aria-hidden="true" className="h-5 w-5" data-id="element-140" data-mp="2bk7kbahfy3ov" />
            Call
          </a>
        </div>
      </div>

      <div className="hidden w-full bg-ink nav:block" data-id="element-141" data-mp="3kih68t7bcf66">
        <div className="mx-auto w-full max-w-[1440px] px-8" data-id="element-142" data-mp="3fje178rc28y7">
          <DesktopNav data-id="element-143" data-mp="3fkxldag41459" />
        </div>
      </div>

      {menuOpen && <MobileMenu id={MENU_ID} onNavigate={() => setMenuOpen(false)} data-id="element-144" data-mp="3tjf0ijry98bk" />}
    </header>;
}